<template>
  <div class="route-dropdown">
    <f7-button
      raised
      :large="large"
      @click="open">
      <FlatIcon
        name="route-active"
        :size="22" />
      {{ t('artRoute') }}
    </f7-button>
    <f7-actions
      :grid="true"
      :opened="actions"
      @actions:closed="close">
      <f7-actions-group>
        <f7-actions-button
          v-for="m in modes"
          :key="m"
          @click="click(m)">
          <FlatIcon
            slot="media"
            :name="`rm-${m}`" />
          <span>{{ t(`rm${m}`) }}</span>
        </f7-actions-button>
      </f7-actions-group>
    </f7-actions>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getRoute } from '@/services/graphhopper'
export default {
  name: 'ArticleBtnRoute',
  props: {
    large: {
      type: Boolean
    },
    marker: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      actions: false,
      modes: [
        'foot',
        'bike',
        'car'
      ],
      mode: '',
      path: null
    }
  },
  computed: {
    ...mapGetters({
      geoActive: 'global/geoActive',
      geoPos: 'global/geoPos'
    }),
    linestring () {
      return this.path && this.path.points ? this.path.points.coordinates.map(p => {
        return [p[1], p[0]]
      }) : []
    }
  },
  methods: {
    ...mapActions({
      geoStart: 'global/geoStart',
      setRouteMarker: 'global/setRouteMarker',
      setRoutePath: 'global/setRoutePath'
    }),
    open () {
      this.actions = true
      this.$emit('open')
    },
    close () {
      this.actions = false
      this.$emit('close')
    },
    click (mode) {
      this.getLocate().then(pos => {
        this.$f7.views.main.router.navigate('/')
        this.$f7.dialog.preloader(this.t('routeLoading'))
        const to = this.marker.coords.slice().reverse()
        getRoute(mode, [pos, to], this.lang).then(res => {
          const path = res.data.paths[0]
          this.setRoutePath(path)
          this.setRouteMarker(this.marker)
        }).finally(() => {
          this.$f7.dialog.close()
        })
      })
    },
    getLocate () {
      return new Promise((resolve, reject) => {
        if (window.gps && this.geoPos) resolve(this.geoPos)
        else if (this.geoActive) resolve(this.geoPos)
        else {
          this.$f7.dialog.preloader(this.t('geoLoading'))
          this.geoStart().then(res => {
            resolve([res.latitude, res.longitude])
            this.$f7.dialog.close()
          }).catch(err => {
            this.$f7.dialog.close()
            this.$f7.notification.create({
              icon: '<span class="flat-icon picto-satellite" style="width: 22px; height: 22px;"></span>',
              title: this.t('notifGeoTitle'),
              text: err.message || this.t('notifGeoError'),
              closeTimeout: 2000
            }).open()
            reject(err)
          })
        }
      })
    },
    getRoute (mode) {
      this.mode = mode
    }
  }
}
</script>

<style lang="scss">
.route-dropdown {
  display: block;
  .button {
    position: relative;
    padding-left: 35px;
  }
  .flat-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translate(0,-50%);
  }
}
</style>
